// src/lib/opportunity/formatCalcLineResolver.ts
//
// Client-side loader for manager calc-line presets at quote time.

import { listFormatCalcLines } from "./formatCalcLineClient";
import {
  FORMAT_CALC_PRODUCT_TYPE_WILDCARD,
  selectFormatCalcLines,
  type FormatCalcLine,
} from "./formatCalcLineTypes";
import type { OpportunityFormatKey } from "@/types/opportunity";

export { selectFormatCalcLines } from "./formatCalcLineTypes";

export async function resolveFormatCalcLines(args: {
  formatKey: OpportunityFormatKey;
  productType: string;
}): Promise<FormatCalcLine[]> {
  const { formatKey, productType } = args;
  const [specific, wildcard] = await Promise.all([
    listFormatCalcLines({ format_key: formatKey, product_type: productType }),
    listFormatCalcLines({
      format_key: formatKey,
      product_type: FORMAT_CALC_PRODUCT_TYPE_WILDCARD,
    }),
  ]);
  return selectFormatCalcLines({
    specificLines: specific.ok ? specific.data.lines : [],
    wildcardLines: wildcard.ok ? wildcard.data.lines : [],
  });
}
